import React from 'react';

import { LayoutRenderer } from './types';

export const HeroOneLayout: LayoutRenderer = ({ children }) => {
  const nodes = React.Children.toArray(children).filter(Boolean);
  const [media] = nodes;

  if (!media) return null;

  return (
    <div className="itv-row-collection__hero1">
      <div className="itv-row-collection__hero1-media">{media}</div>
    </div>
  );
};
